module.exports = __webpack_public_path__ + "static/img/banner.27be67e.png";


//////////////////
// WEBPACK FOOTER
// ./static/answer/banner.png
// module id = Yooa
// module chunks = 1